import { borderColor, BorderColorProps, borderRadius, BorderRadiusProps, borders, BordersProps } from 'styled-system';
import { applyTransientProps, PrependDollar } from './styled-system-helpers';

/**
 * border, border-top, border-right, border-bottom, border-left
 */
export type StyledBordersProps = PrependDollar<BordersProps>;

export const styledBorders = <T extends StyledBordersProps>(props: T) => applyTransientProps(props, borders);

/**
 * border-color
 */
export type StyledBorderColorProps = PrependDollar<BorderColorProps>;

export const styledBorderColor = <T extends StyledBorderColorProps>(props: T) =>
  applyTransientProps(props, borderColor);

/**
 * border-radius
 */
export type StyledBorderRadiusProps = PrependDollar<BorderRadiusProps>;

export const styledBorderRadius = <T extends StyledBorderRadiusProps>(props: T) =>
  applyTransientProps(props, borderRadius);
